module.exports = __webpack_public_path__ + "img/waiting-contracts.6416cc4f.svg";